import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './_styles_/CashLimitRow.css';
import useDetailHandler from '../../hooks/useDetailHandler';
import { onActionKey } from '../../utils';
import { cashLimitType } from '../../types';
import CashLimitDetailTab from './CashLimitDetailTab';
import Number from '../Number';
import DateTime, { LONG_DATE } from '../DateTime';
import {
    getAllCashLimitCreatorsForMapping,
    getCashLimitCreator,
} from '../../utils/CashLimitCreators';
import {
    getAllCashLimitStatuses,
    getCashLimitStatus,
} from '../../utils/CashLimitStatuses';

export const getValueMapping = (t) => {
    const creator = getAllCashLimitCreatorsForMapping().map((cashLimitCreatorForMapping) => ({
        from: cashLimitCreatorForMapping.cashLimit.creator,
        to: cashLimitCreatorForMapping.transform(t),
    }));
    const status = getAllCashLimitStatuses().map((cashLimitStatus) => ({
        from: cashLimitStatus.serverStatus,
        to: cashLimitStatus.translate(t),
    }));
    return {
        creator,
        status,
    };
};

CashLimitRow.propTypes = {
    cashLimit: cashLimitType.isRequired,
};

function CashLimitRow(props) {
    const {
        cashLimit,
    } = props;
    const { t } = useTranslation();
    const { isDetailVisible, toggleDetail } = useDetailHandler(cashLimit.mainId);
    return (
        <>
            <div className="rich-list-row cash-limit-header" onClick={toggleDetail} onKeyUp={onActionKey(toggleDetail)} role="button" tabIndex={0}>
                <div className="rich-list-row--arrow-mobile">
                    <FontAwesomeIcon icon={`caret-${isDetailVisible ? 'down' : 'right'}`} />
                </div>
                <div className="cash-limit-header--values--main-id">{cashLimit.mainId}</div>
                <div className="cash-limit-header--values--member">{cashLimit.member.memberId} ({cashLimit.member.name})</div>
                <div className="cash-limit-header--values--limit-value"><Number value={cashLimit.limitValue} fractionDigits={2} /></div>
                <div className="cash-limit-header--values--begin-date"><DateTime value={cashLimit.beginDate} format={LONG_DATE} /></div>
                <div className="cash-limit-header--values--end-date"><DateTime value={cashLimit.endDate} format={LONG_DATE} /></div>
                <div className="cash-limit-header--values--creator">{getCashLimitCreator(cashLimit).transform(t)}</div>
                <div className="cash-limit-header--values--status">{getCashLimitStatus(cashLimit.status).translate(t)}</div>
                <div className="rich-list-row--arrow">
                    <FontAwesomeIcon icon={`caret-${isDetailVisible ? 'down' : 'right'}`} />
                </div>
            </div>
            {isDetailVisible && (
                <CashLimitDetailTab
                    cashLimit={cashLimit}
                />
            )}
        </>
    );
}

export default CashLimitRow;
